// @core/api/endpoints/product/update_product_dependency.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductDependencyResponse,
  UpdateProductDependencyRequest,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Update product dependency
 * Updates the configuration of an existing product dependency. Changes to requirement level affect future subscription validations.
 */
export async function UpdateProductDependency(
  dependency_id: string,
  data: UpdateProductDependencyRequest,
  options?: RequestOptions
): Promise<ProductDependencyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/dependencies/:dependency_id`;
  requestPath = requestPath.replace(':dependency_id', encodeURIComponent(dependency_id));
  const requestOptions = options;
  return client.put<ProductDependencyResponse>(requestPath, data, requestOptions);
}
